import {
  useActingAsUserId,
  useEffectiveIsSfcAdmin,
  useRound,
} from "../../round-context";
import { isUserFunder } from "@engine/round/accessors";

/**
 * Whether this viewer has a To Do rail at all — the CLIENT mirror of the gate
 * every rail route applies (`all(any(isSfcAdmin, isRoundFunder),
 * isNotRestrictedFunder)`).
 *
 * It exists because the rail's writers and readers are mounted in the round
 * SHELL, not the funder workspace: the general-notes drawer renders for every
 * member of every round. Gating those on "is a target selected" was not
 * enough — a recommender switching the drawer's Viewing selector to a
 * colleague, or a restricted funder opening it at all, produced a target, and
 * then burned React Query's default three retries on a route that will always
 * answer 403, plus a doomed write three seconds later.
 *
 * Duplicating the server's predicate is deliberate: the server still enforces
 * it, and this only decides whether it is worth asking.
 */
export function useCanUseTodoRail(): boolean {
  const round = useRound();
  const actingAsUserId = useActingAsUserId();
  const isSfcAdmin = useEffectiveIsSfcAdmin();
  const isRestrictedFunder =
    round.members[actingAsUserId]?.isRestrictedFunder === true;

  if (isRestrictedFunder) return false;
  return isSfcAdmin || isUserFunder(round, actingAsUserId);
}
